var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7999 10.9C9.52995 10.31 8.79995 9.7 8.79995 8.75C8.79995 7.66 9.80995 6.9 11.4999 6.9C13.2799 6.9 13.9399 7.75 13.9999 9H16.2099C16.1399 7.28 15.0899 5.7 12.9999 5.19V3H9.99995V5.16C8.05995 5.58 6.49995 6.84 6.49995 8.77C6.49995 11.08 8.40995 12.23 11.1999 12.9C13.6999 13.5 14.1999 14.38 14.1999 15.31C14.1999 16 13.7099 17.1 11.4999 17.1C9.43995 17.1 8.62995 16.18 8.51995 15H6.31995C6.43995 17.19 8.07995 18.42 9.99995 18.83V21H12.9999V18.85C14.9499 18.48 16.4999 17.35 16.4999 15.3C16.4999 12.46 14.0699 11.49 11.7999 10.9Z",
    fill: "#888FA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.f8c937889bb36aa0d2fe71b5abe7512a.svg";
export { ForwardRef as ReactComponent };